<template>
    <div class="business">
        <div class="pic">
            <img src="../assets/img/tool－bg.png" alt="">
        </div>
        <main class="business-main">
            <img src="../assets/img/tools－image－1.png" alt="">
            <img src="../assets/img/tools－image－2.jpg" alt="">
            <!-- <img src="../assets/img/tools－image－3.png" alt="">
            <img src="../assets/img/tools－image－4.png" alt=""> -->

        </main>
    </div>
</template>

<script>
export default {
  name: 'business',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>
    /* 图片 */
    .pic {
        width: 100%;
        height: 30%;
        text-align: center;
    }

    .pic img {
        width: 100%;
    }

    .pic p {
        font-size: 34px;
        color: #ffffff;
        margin-top: -12%;
        margin-left: 37%;
    }

    /* 主体内容 */
    .business .business-main {
        width: 70%;
        padding: 0 15%;
        background-color: #f5f5f5;
        position: relative
    }

    .business-main img {
        width: 100%;
        margin-top: -8%;
    }
</style>



// WEBPACK FOOTER //
// src/components/business.vue